import { Button, IconGiftDefault } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'
import { PageSource } from '@mc/track-event'
import { trackPurchaseNowClick } from './SelfServe/utils/events'

/** Offers both self-serve paths up front: seats and corporate gifting. */
export const HeroCTAs = () => {
  const { t } = useTranslation('@mc/next')

  return (
    <div className='d-flex flex-column flex-sm-row align-items-center justify-content-center mc-gap-4 mc-mt-6'>
      <Button
        className='mc-corners--sm'
        render={<a href={paths.enterpriseCart} />}
        onClick={() =>
          trackPurchaseNowClick({
            pageSource: PageSource.MAW_HOME,
            location: 'hero-purchase-seats',
          })
        }
      >
        {t('forBusiness.heroCTA.purchaseSeats')}
      </Button>
      <Button
        kind='tertiary'
        className='mc-corners--sm'
        render={<a href={paths.checkoutEnterpriseGift()} />}
        onClick={() =>
          trackPurchaseNowClick({
            pageSource: PageSource.MAW_HOME,
            location: 'hero-corporate-gifting',
          })
        }
      >
        <IconGiftDefault className='mc-mr-2' aria-hidden='true' />
        {t('forBusiness.heroCTA.corporateGifting')}
      </Button>
    </div>
  )
}
